module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/progress-modal-bg-e02f46add657efaf.png"+" 178w",
        images: [{path: __webpack_public_path__ + "assets/images/progress-modal-bg-e02f46add657efaf.png",width: 178,height: 263}],
        src: __webpack_public_path__ + "assets/images/progress-modal-bg-e02f46add657efaf.png",
        toString: function(){return __webpack_public_path__ + "assets/images/progress-modal-bg-e02f46add657efaf.png"},
        
        width: 178,
        height: 263
      }